import React, { useState } from "react";
import { styled } from '@mui/system';

import Dialog from "@mui/material/Dialog";

import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Typography from "@mui/material/Typography";
import { ThemeProvider, createTheme } from '@mui/material/styles'; 

const theme = createTheme();




const CustomDialogTitle = styled(DialogTitle)(({ theme }) => ({
  fontSize: "16px",
  maxWidth: "864px",
  background: "#3c8dbc",
  color: "#fff",
}));
const CustomDialogContent = styled(DialogContent)(({ theme }) => ({
  padding: theme.spacing(2),
  backgroundColor: "#eaf7fdcc",
}));

const EditVendorStatus = (props) => {
  const [open, setOpen] = React.useState(props.editing);
  const [fullWidth] = React.useState(true);
  const [maxWidth] = React.useState("sm");

  const [vendorStat, setVendorStat] = useState(props.statusData.vendorStatus);
  const [vendorSeqId] = useState(props.statusData.vendorSeqId);
  const [projectId] = useState(props.statusData.projectId);

  const handleClose = () => {
    setOpen(false);
    props.setStaEditing(false);
  };

  const handleStatus = (e) => {
    //alert(e.target.value)
    setVendorStat(e.target.value);
  };

  return (
    <ThemeProvider theme={theme}>
    <div>
      <Dialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
        fullWidth={fullWidth}
        maxWidth={maxWidth}
      >
       <CustomDialogTitle onClose={handleClose}>
          <p style={{ fontSize: "1.5em" }}>Vendor Status</p>
        </CustomDialogTitle>

        <CustomDialogContent dividers>
          <form
            className="form-horizontal "
            style={{ backgroundColor: "#eaf7fdcc" }}
            onSubmit={(event) => {
              event.preventDefault();
              props.editStatusDetails(projectId, vendorSeqId, vendorStat);
              setOpen(false);
            }}
          >
            <div className="form-group">
              <div className="col-md-12">
                <select
                  className="form-control"

                  onChange={handleStatus}
                >
                  <option selected disabled>Select Status</option>
                  <option value="Approved">Approved</option>
                  <option value="Rejected">Rejected</option>
                </select>
              </div>
            </div>

            <div className="form-group">
              <div className="col-sm-offset-2 col-sm-10">
                <button
                  style={{ marginLeft: "51%", marginTop: "5%" }}
                  onClick={handleClose}
                  type="button"
                  className="btn muted-button  deca-btn-orange a-btn-cancel"
                >
                  Cancel
                </button>

                <button
                  className="btn btn-secondary deca-btn-yellow a-update-email-alert"
                  style={{ marginLeft: "2%", marginTop: "5%" }}
                >
                  Update Status
                </button>
              </div>
            </div>
          </form>
        </CustomDialogContent>
      </Dialog>
    </div>
    </ThemeProvider>
  );
};
export default EditVendorStatus;
